// extracted by mini-css-extract-plugin
export default {"about":"about_about__LgMQk","buttonWrapper":"about_buttonWrapper__mUiHi","title":"about_title__4UDE8","link":"about_link__3Vkus"};